function Navigation({ find, nevigationlist }) {
    return (
        <>
            <ul className="nav">
                {
                    nevigationlist.map((manulist) => {
                        return (
                            <li className="nav-item" onClick={() => find(manulist)}>
                                <a className="nav-link " href="#">{manulist}</a>
                            </li>
                        )
                    })
                }
            </ul>
        </>
    )
}

export default Navigation;